import React from 'react';
import { SurveyQuestion } from '../../../types/survey';
import { getEnabledTextQuestions, getRatingQuestion, SURVEY_RATING_MAX } from '../surveyUtils';

interface Props {
  questions: SurveyQuestion[];
  locale: string | undefined;
}

const RATING_VALUES = Array.from({ length: SURVEY_RATING_MAX }, (_, index) => index + 1);

/** Approximate picture of the window the app shows. Not interactive. */
export function SurveyPreview({ questions, locale }: Props): React.ReactElement {
  const textQuestions = getEnabledTextQuestions(questions);
  const rating = getRatingQuestion(questions);
  const textOf = (question: SurveyQuestion, fallback: string): string =>
    (locale ? question.texts[locale]?.trim() : '') || fallback;
  const isEmpty = textQuestions.length === 0 && !rating;

  return (
    <aside className='survey-preview' aria-label='Vista previa en la app'>
      <span className='survey-preview-caption'>Vista previa en la app</span>
      <div className='survey-preview-phone' aria-hidden>
        <div className='survey-preview-sheet'>
          <strong className='survey-preview-title'>Encuesta</strong>
          <p className='survey-preview-intro'>Es anónima y te llevará un minuto.</p>
          {isEmpty && <p className='survey-preview-empty'>Añade al menos una pregunta.</p>}
          {textQuestions.map((question, index) => (
            <div key={question.slot} className='survey-preview-question'>
              <span>
                {textOf(question, `Pregunta ${index + 1}`)}
                {question.required && <em> *</em>}
              </span>
              <div className='survey-preview-textarea'>Escribe tu respuesta</div>
            </div>
          ))}
          {rating && (
            <div className='survey-preview-question'>
              <span>
                {textOf(rating, 'Valoración')}
                {rating.required && <em> *</em>}
              </span>
              <div className='survey-preview-scale'>
                {RATING_VALUES.map((value) => (
                  <span key={value}>{value}</span>
                ))}
              </div>
            </div>
          )}
          <div className='survey-preview-submit'>Enviar encuesta</div>
        </div>
      </div>
    </aside>
  );
}
